<template>
  <div>
    <!-- <TopBar msg="topbar" /> ---tob bar include--->
    <div class="d-flex justify-content-center">
      <div class="card signup-out">
        <div class="card-body">
          <div class="d-flex flex-column align-items-center">
            <a href="#">
              <h4 v-on:click="goDashboard"><img src="../../src/assets/images/spade-logo.png" id="logo"></h4>
            </a>
            <br>
            <h1 class="card-title">Sign up</h1>
          </div>
          <form name="form" @submit.prevent="handleRegister">
            <div v-if="!successful">
              <div class="form-group">
                <label for="tenant">Tenant</label>
                <b-form-select name="tenant" v-model="user.tenant" :options="tenantList" size="md" class="mr-4" v-validate="'required'" />
                <div class="alert-danger" v-if="submitted && errors.has('tenant')">{{ errors.first('tenant') }}</div>
              </div>
              <!-- <div class="form-group">
                <label for="role">Role</label>
                <b-form-select v-model="user.role" :options="roleOptions" size="md" class="mr-4" v-validate="'required'">
                </b-form-select>
                <div class="alert-danger" v-if="submitted && errors.has('role')">{{ errors.first('role') }}</div>
              </div>-->
              <div class="form-group">
                <label for="email">ID</label>

                <input type="email" class="form-control" name="email" placeholder="example@gmail.com" v-model="user.id"
                       v-validate="'required|email|max:50'" />
                <div class="alert-danger" v-if="submitted && errors.has('email')">{{ errors.first('email') }}</div>
              </div>
              <div class="form-group">
                <label for="username">Username</label>
                <input type="text" class="form-control" name="username" v-model="user.name"
                       v-validate="'required|min:3|max:20'" />
                <div class="alert-danger" v-if="submitted && errors.has('username')">{{ errors.first('username') }}</div>
              </div>
              <div class="form-group">
                <label for="password">Password</label>
                <input type="password" class="form-control" name="password" v-model="user.password"
                       v-validate="'required|min:6|max:40'" @keypress="showReEnterField(user.password)" />
                <div class="alert-danger" v-if="submitted && errors.has('password')">{{ errors.first('password') }}</div>
              </div>
              <div class="form-group">
                <label for="rePassword"><i class="fas fa-angle-right signup-color"> Password 확인</i></label>
                <input type="password" class="form-control" name="rePassword" v-model="user.rePassword"
                       v-validate="'required|min:6|max:40'" />
                <div class="alert-danger" v-if="submitted && rePasswordErrorFlag">{{ rePasswordError }}</div>
              </div>
              <div class="form-group">
                <button class="btn  btn-block btn-signup">Sign Up</button>
              </div>
              <div class="form-group text-center">
                <a href @click="goSign" class="">{{ showSign() }}</a>
              </div>
            </div>
          </form>

          <div class="alert" :class="successful ? 'alert-success' : 'alert-danger'" v-if="message">{{ message }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.hide-component {
  display: none;
}
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import User from '../models/user';
import TopBar from '@/components/TopBar.vue'
import { Decrypt, Encrypt } from '@//utils.js'
import { TrackOpTypes } from 'vue';

export default {
  name: 'signup',
  components: {
    Loading, TopBar
  },
  created() {
    this.retrieveTenantList();
  },
  mounted() {
    this.rePasswordError = '';
    this.rePasswordErrorFlag = false;
  },
  computed: {
    authenticated() {
      return this.$store.state.auth.status.authenticated;
    }
  },
  // watch: {
  //   user:{
  //     deep:true,
  //     handler(){
  //       console.log("tenant : "+this.user.tenant);
  //     }
  //   }
  // },
  data() {
    return {
      user: new User('', '', '', '', ''),
      submitted: false,
      successful: false,
      message: '',
      tenantSelected: '',
      tenantList: [
      ],
      rePasswordVisible: false,
      rePasswordErrorFlag: false,
      rePasswordError: 'Password does not match.',
    };
  },
  methods: {
    async handleRegister() {
      this.submitted = true;
      //let returnFlag = false;

      if ((this.user.rePassword == null || this.user.rePassword === '') || this.user.rePassword.trim() !== this.user.password.trim()) {
        this.rePasswordErrorFlag = true;
        this.rePasswordError = 'Password does not match.'
        return;
      }

      const cloneObj = obj => JSON.parse(JSON.stringify(obj));
      let userInfo = cloneObj(this.user);

      const encrynped = Encrypt(this.user.password);

      if (encrynped == null) {
        this.showMessage(-1, "[System error] password is null");
        return;
      }
      userInfo.password = encrynped;
      
      // Validate the login form
      await this.$validator.validateAll();
      // If the validation failed, return
      if (this.errors.any()) {
          return;
      }
      try{
        const response = await this.$store.dispatch('auth/register', userInfo);
            
        let resultMessage = response.data.message;
        let resultCode = response.data.code;

        if(resultCode == "0"){
          this.successful = true;
          this.$router.push('/signin');
        }else{
          this.successful = false;
          this.message = resultMessage;
        }
      }catch(error){
        this.successful = false;
        this.message = error.message;
      }
    },
    showReEnterField(password) {
      if (this.rePasswordVisible === false) {
        this.rePasswordVisible = true;
      }
    },
    showMessage(status, message) {
      this.msgStatus = status;
      this.msgContent = message;
      this.$bvModal.show('messageModal');
    },
    retrieveTenantList() {
      var params = {};
      this.tenantList.push({ value: '', text: '선택' });

      axios.get('user/retrieveTenantList', {
        params: params,
        headers: {
          'Accept': 'application/json',
          'Authorization': accessToken()
        }
      }).then(response => {
        response.data.body.list.forEach((item, index, array) => {
          this.tenantList.push({ value: item.tenantId, text: item.tenantName });
        });
      }).catch(error => {
        if (error.status != 401) {
          this.showMessage(error.status == 200 ? error.code : error.status, error.message);
        }
      }).finally(() => {
      });
    },
    goDashboard: function (event) {
      this.$router.push('/dashboard');
    },
    goSign() {
      if (this.$router.currentRoute.name === 'signup') {
        this.$router.push('signin');
      }
    },
    showSign() {
      if (this.$router.currentRoute.name === 'signup') {
        return 'Sign In';
      }
    },
  }
};
</script>

<style scoped></style>